import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

//apies
import { loginApi } from "./apis/loginApi";
import { adminApi } from "./apis/adminApi";
import { companyApi } from "./apis/companyApi";
import { excelDocApi } from "./apis/excelDocApi";
import { executionLogApi } from "./apis/executionLogApi";
import { s3Api } from "./apis/s3Api";
import { userApi } from "./apis/userApi";
import { vipApi } from "./apis/vipApi";
import { employeeApi } from "./apis/employeeApi";

//reducers
import { userSlice } from "./reducers/userSlice";
import { excelSlice } from "./reducers/excelSlice";
import { searchSlice } from "./reducers/searchSlice";
import { vipSlice } from "./reducers/vipSlice";
import { hrSlice } from "./reducers/hrSlice";
import { notificationSlice } from "./reducers/notificationSlice";
import { searchHistorySlice } from "./reducers/searchHistorySlice";

const persistConfig = {
  key: "user",
  storage,
  version: 2,
  whitelist: ["user", "meta"],
};

const persistConfigExcel = {
  key: "excel",
  storage,
};

const rootReducer = {
  [loginApi.reducerPath]: loginApi.reducer,
  [userSlice.name]: persistReducer(persistConfig, userSlice.reducer),
  [adminApi.reducerPath]: adminApi.reducer,
  [companyApi.reducerPath]: companyApi.reducer,
  [s3Api.reducerPath]: s3Api.reducer,
  [excelDocApi.reducerPath]: excelDocApi.reducer,
  [executionLogApi.reducerPath]: executionLogApi.reducer,
  [excelSlice.name]: persistReducer(persistConfigExcel, excelSlice.reducer),
  [userApi.reducerPath]: userApi.reducer,
  [searchSlice.name]: searchSlice.reducer,
  [searchHistorySlice.name]: searchHistorySlice.reducer,
  [vipApi.reducerPath]: vipApi.reducer,
  [vipSlice.name]: vipSlice.reducer,
  [hrSlice.name]: hrSlice.reducer,
  [notificationSlice.name]: notificationSlice.reducer,
  [employeeApi.reducerPath]: employeeApi.reducer,
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(loginApi.middleware)
      .concat(adminApi.middleware)
      .concat(companyApi.middleware)
      .concat(s3Api.middleware)
      .concat(excelDocApi.middleware)
      .concat(executionLogApi.middleware)
      .concat(userApi.middleware)
      .concat(vipApi.middleware)
      .concat(employeeApi.middleware),
});

export const persistore = persistStore(store);

setupListeners(store.dispatch);

// export default store;

export { store };

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
